import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../assets/static/illustrations/onboarding/biggest-planet.svg'
import _imports_1 from '../../../../assets/static/illustrations/onboarding/smallest-planet.svg'
import _imports_2 from '../../../../assets/static/illustrations/onboarding/astronaut.png'


const _withScopeId = n => (_pushScopeId("data-v-4cbbe437"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layout" }
const _hoisted_2 = { class: "layout__welcome" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageBox = _resolveComponent("MessageBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, " Bem-vindo(a) ao Decola, " + _toDisplayString($setup.userName), 1),
    _createVNode(_component_MessageBox, {
      class: _normalizeClass(['layout__message', { reverse: $props.animationIsReverse }]),
      message: $props.message,
      direction: "right"
    }, null, 8, ["class", "message"]),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__biggest-planet', { reverse: $props.animationIsReverse }]),
      src: _imports_0,
      alt: "Planeta grande"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass(['layout__smallest-planet', { reverse: $props.animationIsReverse }]),
      src: _imports_1,
      alt: "Planeta pequeno"
    }, null, 2),
    _createElementVNode("img", {
      class: _normalizeClass([
        'layout__astronaut',
        { 'fade-in': _ctx.$route.params.step == '2' },
        { 'fluctuate-facing-right': $setup.isTransitionFinished },
        { reverse: $props.animationIsReverse },
      ]),
      src: _imports_2,
      alt: "Astronauta",
      onAnimationend: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.fluctuate && $setup.fluctuate(...args)))
    }, null, 34)
  ]))
}